/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 13:58:27
 * @LastEditors: linxi
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Modal,
  ModalProps,
  Form,
  Steps,
  Col,
  Radio,
  Row,
  Space,
  Select,
  Input,
  Cascader as Cascaded,
  Button,
  notification,
  Switch,
} from 'antd'
import React, { ReactElement, useEffect, useState, useContext, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCredentials } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { replaceMakeInfoParams } from '../../../../services/recipe'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { stringTrim } from '../../../../utils/StringUtils'
import { pageExamineAsync } from '../../../examinetreat/examinetreatSlice'
import { getAddress } from '../../../registration/register/registerSlice'
import {
  getDecoctingPersonalSettingAsync,
  getPotionpreferencesSettingAsync,
  getReplaceMakeSettingDetail,
} from '../recipeEditorSlice'
import styles from './RecipeItemModal.module.css'
import {
  RecipeNormalDoseCategories,
  RecipeNormalDoseTypeName,
  RecipeNormalFrequencyCategories,
  RecipeNormalFrequencyName,
  RecipeNormalUsemethodCategories,
  RecipeNormalUsemethodName,
} from '../../../../models/decoctingSettingModal'

let potionMoneyAllList: any = []

interface ReplaceMakeSettingModalProps {
  selectSupplierId?: any
  selectId?: any
  selectPotionType?: any
  recipeId?: number
  patientId?: number
  recipeCategory?: number
  isSetting?: boolean
  isOpenReplaceMake?: any
  onOk?: () => void
  onCancel?: () => void
  visible?: boolean
}

export const DecoctingPersionalSettingModal = ({
  selectSupplierId,
  selectId,
  selectPotionType,
  recipeId,
  patientId,
  recipeCategory,
  isSetting,
  isOpenReplaceMake,
  onOk,
  onCancel,
  visible,
}: ReplaceMakeSettingModalProps & ModalProps): ReactElement => {
  const { Step } = Steps

  const dispatch = useDispatch<RootDispatch>()

  const credentials = useSelector(selectCredentials)

  const theme = useContext(ThemeContext)

  const [needMoney, setNeedMoney] = useState(true)

  const [form] = Form.useForm()

  const [stepValue, setStepValue] = useState(0)

  const [
    herbalMedicineFactoryList,
    setHerbalMedicineFactoryList,
  ] = useState<any>([]) //代煎饮片厂

  const [spuLIst, setSpuLIst] = useState<any>([])

  const spuLIstRef = useRef<any>([]) // 使用 ref 避免闭包过期问题

  const [machiningTypeOptions, setMachiningTypeOptions] = useState<any>([]) // 代煎方式选项

  const [potionMoneyList, setPotionMoneyList] = useState<any>() //费用类别

  const [allAreaList, setAllAreaList] = useState<any[]>()

  const [potionTypeValue, setPotionTypeValue] = useState<any>()

  const [submitValue, setSubmitValue] = useState<any>()

  const [potionMoneyId, setPotionMoneyId] = useState<any>('')

  const [autoBackFillPhoneFlag, setAutoBackFillPhoneFlag] = useState('1')

  const [supplierId, setSupplierId] = useState<any>()

  const rowProps = {
    gutter: 2,
  }

  const colProps = { span: 24 }

  const inputSelectLayout = {
    style: { width: '284px' },
  }
  const RadioLayout = {
    style: { width: '200px', lineHeight: '34px' },
  }
  const detailRowStyle = {
    marginBottom: '32px',
    alignItems: 'center',
  }
  const detailLabelStyle = {
    lineHeight: '32px',
    textAlign: 'right',
    paddingRight: '12px',
  } as React.CSSProperties
  const detailSelectStyle = {
    width: '100%',
  }
  const localContentStyle = {
    paddingTop: '4px',
    paddingBottom: '12px',
    overflow: 'hidden',
  } as React.CSSProperties
  const localRowStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: '32px',
    marginBottom: '24px',
  } as React.CSSProperties
  const localLabelStyle = {
    width: '116px',
    flex: '0 0 116px',
    lineHeight: '32px',
    textAlign: 'right',
    paddingRight: '14px',
    whiteSpace: 'nowrap',
  } as React.CSSProperties
  const localContentColStyle = {
    flex: 1,
    minWidth: 0,
  } as React.CSSProperties
  const localRadioGroupStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '32px',
    rowGap: '8px',
    lineHeight: '32px',
  } as React.CSSProperties
  const localFeeSwitchStyle = {
    width: '92px',
    flex: '0 0 92px',
    lineHeight: '32px',
  } as React.CSSProperties
  const localFeeLabelStyle = {
    ...localLabelStyle,
    width: '116px',
    flex: '0 0 116px',
  } as React.CSSProperties
  const localFeeSelectWrapStyle = {
    flex: 1,
    minWidth: 0,
  } as React.CSSProperties
  const localRecipeSelectStyle = {
    width: '100%',
  }
  const localRecipeSelectWrapStyle = {
    flex: 1,
    minWidth: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    columnGap: '8px',
  } as React.CSSProperties
  const localTextStyle = {
    lineHeight: '32px',
  }

  useEffect(() => {
    if (visible) {
      localStorage.setItem('notUseGlobalKeyboardAction', 'true')
      setStepValue(0)
      const provinceCode = credentials?.tenantProvinceCode
        ? Number(credentials?.tenantProvinceCode + '000000')
        : ''
      const cityCode = credentials?.tenantCityCode
        ? Number(credentials?.tenantCityCode + '000000')
        : ''
      const countryCode = credentials?.tenantCountyCode
        ? Number(credentials?.tenantCountyCode + '000000')
        : ''

      const tenantAddress = credentials?.tenantAddress
        ? credentials?.tenantAddress
        : ''
      form.setFieldsValue({
        area: provinceCode
          ? [Number(provinceCode), Number(cityCode), Number(countryCode)]
          : [],
        includeDecoctionFee: false,
        addressType: 0,
        usePatientPhone: '1',
      })
      setNeedMoney(false)
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      if (!needMoney)
        form.setFieldsValue({
          potionMoney: '',
        })
    }
  }, [visible, needMoney])

  useEffect(() => {
    if (visible) {
      if (selectPotionType?.toString()) {
        setPotionTypeValue(selectPotionType)
      }
    } else {
      setPotionTypeValue('')
    }
  }, [visible, selectPotionType])

  useEffect(() => {
    if (visible) {
      // 获取费用类别
      getExamineAsync()

      // 获取收货地区
      getAddressList()
      const data: replaceMakeInfoParams = {
        decoctionType:
          location.pathname === '/retail' //(快速开单) && recipeCategory === 3 //(中药3)
            ? 2
            : recipeCategory === 3 //(中药3)
              ? 0
              : 1,
        patientId: patientId,
        tenantRecipeId: recipeId!,
      }
      dispatch(getReplaceMakeSettingDetail({ ...data }))
        .then(unwrapResult)
        .then((res: any) => {
          // 判断有没有代煎饮片厂
          if (res?.supplierRespVOS?.length) {
            // 获取代煎饮片厂
            setHerbalMedicineFactoryList([...res?.supplierRespVOS])
            setSpuLIst([...res?.supplierRespVOS])
            spuLIstRef.current = [...res?.supplierRespVOS]
          }
        })


    }
  }, [visible, recipeCategory, selectSupplierId])

  const getExamineAsync = () => {
    dispatch(
      // 获取费用类别
      pageExamineAsync({
        current: 1,
        size: 1000,
        state: 1,
        billingCategory: '97',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        potionMoneyAllList = res.records
        setPotionMoneyList(res.records)
        // setPotionMoneyId(res.records?.[0]?.id)
      })
  }

  const getAddressList = () => {
    // 获取收货地区
    dispatch(getAddress())
      .then(unwrapResult)
      .then((res: any) => {
        setAllAreaList(res)
      })
  }

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  useEffect(() => {
    if (visible) {
      // 获取本地代煎数据回填信息
      if (selectId > 0) {
        getPotionpreferencesData(selectId)
      } else if (selectPotionType == 0) {
        form.setFieldsValue({
          machiningType: 4,
          includeDecoctionFee: false,
          potionMoney: '',
          recipeNormalFrequency: '每日一帖',
          recipeNormalUsemethod: '每帖一次',
          recipeNormalDose: '每次100ml',
        })
        setNeedMoney(false)
        setPotionMoneyId('')
      } else {
        form.setFieldsValue({
          recipeNormalFrequency: '每日一帖',
          recipeNormalUsemethod: '每帖两次',
          recipeNormalDose: '每次200ml',
        })
      }
    }
  }, [visible, selectId])

  const getPotionpreferencesData = (v?: any) => {
    dispatch(getPotionpreferencesSettingAsync(v))
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) != '{}') {
          // 使用 ref 获取最新的 spuLIst，避免因闭包过期导致加工方式选项为空
          const currentSpuList = spuLIstRef.current?.length ? spuLIstRef.current : spuLIst
          MachiningTypeData(currentSpuList, v?.supplierId)
          setSupplierId(selectSupplierId)
          const flag =
            v?.treatmentServiceCatalogId && v?.treatmentServiceCatalogId != -1
          setTimeout(() => {
            const isValidPotionMoney = potionMoneyAllList?.some((item: any) => item.id == v?.treatmentServiceCatalogId)
            form.setFieldsValue({
              ...v,
              potionMoney: flag ? isValidPotionMoney ? v?.treatmentServiceCatalogId : '' : '',
              area:
                v?.province && v?.city && v?.region
                  ? [Number(v?.province), Number(v?.city), Number(v?.region)]
                  : [],
              // carryType: v?.carryTypeDefault,
              addressType: v?.addressType == 1 ? 1 : 0,
              usePatientPhone: v?.usePatientPhone?.toString(),
              recipeNormalFrequency: v?.recipeNormalFrequency,
              recipeNormalUsemethod: v?.recipeNormalUsemethod,
              recipeNormalDose: v?.recipeNormalDose,
            })
          }, 100)
          setNeedMoney(flag ? true : false)
          if (v?.usePatientPhone?.toString() == '0') {
            setAutoBackFillPhoneFlag(v?.usePatientPhone?.toString())
          }
          if (
            !v?.treatmentServiceCatalogId ||
            v?.treatmentServiceCatalogId == -1
          ) {
            form.setFieldsValue({
              potionMoney: '',
            })
          }
        }
      })
  }

  useEffect(() => {
    if (visible) {
      // 使用 supplierId state 或 selectSupplierId prop 作为表单值的兜底
      // 避免因 setTimeout 导致 form.getFieldValue('supplierId') 尚未设置
      const effectiveSupplierId =
        form.getFieldValue('supplierId') || supplierId || selectSupplierId
      if (spuLIst?.length && effectiveSupplierId) {
        MachiningTypeData(spuLIst, effectiveSupplierId)
      }
    }
  }, [visible, spuLIst, supplierId, selectSupplierId])

  const reset = () => {
    form.resetFields()
    setMachiningTypeOptions([])
    setSupplierId('')
    localStorage.setItem('notUseGlobalKeyboardAction', 'false')
  }

  // 加工方式获取方法
  const MachiningTypeData = (supplierRespVOS?: any, supplierId?: any) => {
    const TypeOptions = supplierRespVOS?.find(
      (item: any) => supplierId == item?.id
    )
    TypeOptions && setMachiningTypeOptions([...TypeOptions?.outPotionDictList])
  }
  return (
    <Modal
      visible={visible}
      title='代煎偏好设置'
      width={820}
      maskClosable={false}
      footer={null}
      className={styles.persionalSetting}
      destroyOnClose
      style={{ overflow: 'hidden', padding: '0' }}
      bodyStyle={
        selectPotionType == 0
          ? { padding: '12px 24px 16px 24px', overflow: 'hidden' }
          : { padding: '10px 15px 0 15px', height: 480, overflow: 'auto' }
      }
      onCancel={(e) => {
        onCancel && onCancel(e)
        reset()
      }}
      onOk={(e) => {
        onOk && onOk()
        reset()
      }}
    >
      {selectPotionType == 0 ? null : (
        <div style={{ margin: '10px 60px 24px 60px' }}>
          <Steps size='small' current={stepValue} labelPlacement={'vertical'}>
            <Step title='代煎方式设置' />
            <Step title='代煎详情设置' />
            <Step title='配送信息设置' />
          </Steps>
        </div>
      )}

      <Form
        form={form}
        colon={false}
        autoComplete='off'
        labelAlign='left'
        onFinish={(value) => {
          if (potionTypeValue?.toString() == 0) {
            if (!value?.machiningType || value?.machiningType == -1) {
              notification.info({ message: '请选择默认加工方式' })
              return
            }
            if (needMoney && !value?.potionMoney) {
              notification.info({ message: '请选择默认费用类别' })
              return
            }
          }
          const potionMoney = potionMoneyList?.find((item: any) => {
            return item?.id == (potionMoneyId || value?.potionMoney)
          })?.retailPrice
          const potionMoneys = potionMoneyList?.find((item: any) => {
            return item?.id == (potionMoneyId || submitValue?.potionMoney)
          })?.retailPrice
          const id =
            potionTypeValue?.toString() == 0
              ? potionMoneyId || value?.potionMoney
              : potionMoneyId || submitValue?.potionMoney
          const submitParam =
            potionTypeValue?.toString() == 0
              ? {
                ...submitValue,
                ...value,
                potionMoney: potionMoney,
                potionType: potionTypeValue,
                treatmentServiceCatalogId: id || '0',
                defaultSelected: 0,
                includeDecoctionFee: value?.includeDecoctionFee ? 1 : 0,
              }
              : {
                ...submitValue,
                ...value,
                potionType: potionTypeValue,
                province: value?.area?.[0],
                city: value?.area?.[1],
                region: value?.area?.[2],
                treatmentServiceCatalogId: id || '0',
                defaultSelected: 0,
                potionMoney: potionMoneys,
                includeDecoctionFee: submitValue?.includeDecoctionFee ? 1 : 0,
                area: null,
                autoAddress: null,
              }
          setSubmitValue({ ...submitValue, ...value })
          dispatch(getDecoctingPersonalSettingAsync({ ...submitParam }))
            .then(unwrapResult)
            .then((v: any) => {
              notification.success({
                message: '操作成功',
              })
              onOk && onOk()
              reset()
            })
        }}
      >
        {selectPotionType == 0 ? (
          <>
            <Row style={localContentStyle}>
              <Col span={24}>
                <Row style={localRowStyle}>
                  <Col style={localLabelStyle}>代煎方式</Col>
                  <Col style={{ ...localContentColStyle, ...localTextStyle }}>本地</Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row style={localRowStyle}>
                  <Col style={localLabelStyle}>默认加工方式</Col>
                  <Col style={localContentColStyle}>
                  <Form.Item name='machiningType' noStyle>
                    <Radio.Group style={localRadioGroupStyle}>
                      <Radio value={4}>
                        本地代煎袋装液体
                      </Radio>
                      <Radio value={5}>本地代煎颗粒剂</Radio>
                    </Radio.Group>
                  </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row style={localRowStyle}>
                  <Col style={localLabelStyle}>默认代煎费</Col>
                  <Col style={localFeeSwitchStyle}>
                  <Form.Item name='includeDecoctionFee' noStyle>
                    <Switch
                      checkedChildren='添加'
                      unCheckedChildren='关闭'
                      checked={needMoney}
                      onChange={(v) => {
                        setNeedMoney(v)
                        if (v) {
                          form.setFieldsValue({
                            potionMoney: potionMoneyList?.[0]?.id,
                          })
                          setPotionMoneyId(potionMoneyList?.[0]?.id)
                        } else {
                          form.setFieldsValue({
                            potionMoney: '',
                          })
                          setPotionMoneyId('')
                        }
                      }}
                    />
                  </Form.Item>
                  </Col>
                  {needMoney && (
                    <>
                      <Col style={localFeeLabelStyle}>默认费用类别</Col>
                      <Col style={localFeeSelectWrapStyle}>
                      <Form.Item name='potionMoney' noStyle>
                        <Select
                          allowClear
                          style={detailSelectStyle}
                          placeholder='请选择'
                          onSelect={(v: any) => {
                            setPotionMoneyId(v)
                          }}
                          onClear={() => {
                            setPotionMoneyId('')
                          }}
                        >
                          {potionMoneyList?.map((el: any) => (
                            <Select.Option key={el.id} value={el.id}>
                              {el.name}: {el.retailPrice} 元
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </Col>
              <Col span={24}>
                <Row style={localRowStyle}>
                  <Col style={localLabelStyle}>默认处方剂型</Col>
                  <Col style={localRecipeSelectWrapStyle}>
                  <Form.Item name='recipeNormalFrequency' noStyle>
                    <Select placeholder='请选择' allowClear style={localRecipeSelectStyle}>
                      {RecipeNormalFrequencyCategories?.map((v) => {
                        return (
                          <Select.Option value={v} key={v}>
                            {RecipeNormalFrequencyName(v)}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name='recipeNormalUsemethod' noStyle>
                    <Select placeholder='请选择' allowClear style={localRecipeSelectStyle}>
                      {RecipeNormalUsemethodCategories?.map((v) => {
                        return (
                          <Select.Option value={v} key={v}>
                            {RecipeNormalUsemethodName(v)}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name='recipeNormalDose' noStyle>
                    <Select placeholder='请选择' allowClear style={localRecipeSelectStyle}>
                      {RecipeNormalDoseCategories?.map((v) => {
                        return (
                          <Select.Option value={v} key={v}>
                            {RecipeNormalDoseTypeName(v)}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        ) : (
          <div
            style={{ height: '330px', overflowY: 'auto', overflowX: 'hidden' }}
          >
            {stepValue == 0 && potionTypeValue != 2 && (
              <>
                {!isOpenReplaceMake ? (
                  <Row {...rowProps}>
                    <Col {...colProps}>
                      <Form.Item
                        label='选择委外饮片厂'
                        name='supplierId'
                        style={{
                          position: 'relative',
                        }}
                      >
                        <>
                          您尚未开通委外代煎服务，请联系客服申请开通，了解
                          <a
                            href='javascript:;'
                            style={{
                              color: '#0076FF',
                              textDecoration: 'underline',
                            }}
                            onClick={() => {
                              window.open(
                                window.location.origin + '/productCenter',
                                '_blank'
                              )
                            }}
                          >
                            更多详情
                          </a>{' '}
                          <br />
                          客服联系方式：
                          <span
                            style={{
                              color: '#0076FF',
                            }}
                          >
                            17300983625
                          </span>
                        </>
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <Row {...rowProps}>
                    <Col {...colProps}>
                      <Form.Item
                        label='选择委外饮片厂'
                        name='supplierId'
                        style={{
                          position: 'relative',
                        }}
                      >
                        <Radio.Group
                          onChange={(e) => {
                            const { value } = e.target
                            MachiningTypeData(spuLIst, value)
                            setSupplierId(value)
                            form.setFieldsValue({
                              machiningType: '',
                              potionMoney: '',
                              specification: '',
                              remark: '',
                            })
                            setNeedMoney(false)
                          }}
                        >
                          {herbalMedicineFactoryList?.map((v: any) => (
                            <Radio value={v.id} key={v.id} {...RadioLayout}>
                              <Row align='middle'>{v.supplierName}</Row>
                              {v.signedType == 0 && (
                                <div
                                  style={{
                                    backgroundColor: '#DDEDFF',
                                    padding: '5px 10px',
                                  }}
                                >
                                  {v.signedMsg}
                                </div>
                              )}
                            </Radio>
                          ))}
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='默认委外加工方式' name='machiningType'>
                      <Radio.Group
                        onChange={(e) => {
                          return
                        }}
                      >
                        {machiningTypeOptions?.length ? (
                          machiningTypeOptions?.map((v: any) => (
                            <Radio
                              value={v.typeVal}
                              key={v.id}
                              {...RadioLayout}
                            >
                              {v.name}
                            </Radio>
                          ))
                        ) : (
                          <div>请先选择委外饮片厂</div>
                        )}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {stepValue == 1 && potionTypeValue != 2 && (
              <>
                <Row gutter={12} style={detailRowStyle}>
                  <Col span={3} style={detailLabelStyle}>代煎费</Col>
                  <Col span={5}>
                    <Form.Item name='includeDecoctionFee' noStyle>
                      <Switch
                        checkedChildren='开启'
                        unCheckedChildren='关闭'
                        checked={needMoney}
                        onChange={(v) => {
                          setNeedMoney(v)
                          // 代煎费关闭的情况下,费用类别置灰并且清空
                          if (v) {
                            form.setFieldsValue({
                              potionMoney: potionMoneyList?.[0]?.id,
                            })
                          } else {
                            form.setFieldsValue({
                              potionMoney: '',
                            })
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  {needMoney && (
                    <>
                      <Col span={3} style={detailLabelStyle}>费用类别</Col>
                      <Col span={9}>
                        <Form.Item name='potionMoney' noStyle>
                      <Select
                        style={detailSelectStyle}
                        placeholder='请选择费用类别'
                        onSelect={(v: any, s: any) => {
                          setPotionMoneyId(v)
                        }}
                      >
                        {potionMoneyList?.map((el: any) => (
                          <Select.Option key={el.id} value={el.id}>
                            {el.name}: {el.retailPrice} 元
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
                {/* <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='默认包装规格' name='specification'>
                      <Input
                        maxLength={15}
                        placeholder='请输入包装规格'
                        {...inputSelectLayout}
                      />
                    </Form.Item>
                  </Col>
                </Row> */}
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='处方剂型'>
                      <div style={localRecipeSelectWrapStyle}>
                        <Form.Item name='recipeNormalFrequency' noStyle>
                          <Select
                            placeholder='请选择'
                            allowClear
                            style={localRecipeSelectStyle}
                          >
                            {RecipeNormalFrequencyCategories?.map((v) => {
                              return (
                                <Select.Option value={v} key={v}>
                                  {RecipeNormalFrequencyName(v)}
                                </Select.Option>
                              )
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item name='recipeNormalUsemethod' noStyle>
                          <Select
                            placeholder='请选择'
                            allowClear
                            style={localRecipeSelectStyle}
                          >
                            {RecipeNormalUsemethodCategories?.map((v) => {
                              return (
                                <Select.Option value={v} key={v}>
                                  {RecipeNormalUsemethodName(v)}
                                </Select.Option>
                              )
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name='recipeNormalDose'
                          noStyle
                        >
                          <Select
                            placeholder='请选择'
                            allowClear
                            style={localRecipeSelectStyle}
                          >
                            {RecipeNormalDoseCategories?.map((v) => {
                              return (
                                <Select.Option value={v} key={v}>
                                  {RecipeNormalDoseTypeName(v)}
                                </Select.Option>
                              )
                            })}
                          </Select>
                        </Form.Item>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='默认备注' name='remark'>
                      <Input
                        maxLength={30}
                        placeholder='请输入备注'
                        style={{ width: '600px' }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {stepValue == 2 && potionTypeValue != 2 && (
              <>
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='默认收货位置' name='addressType'>
                      <Select
                        placeholder='请选择默认收货位置'
                        {...inputSelectLayout}
                      >
                        <Select.Option key={0} value={0}>
                          患者地址
                        </Select.Option>
                        <Select.Option key={1} value={1}>
                          诊所自取
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='默认配送方式' name='carryTypeDefault'>
                      <Select
                        placeholder='请选择默认配送方式'
                        {...inputSelectLayout}
                      >
                        {carryTypeNumType?.map((v: any) => (
                          <Select.Option key={v} value={v}>
                            {getCarryTypeName(v)}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row> */}
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Row>
                      <Form.Item label='诊所收货地址' name='area'>
                        <Cascaded
                          {...inputSelectLayout}
                          loadData={loadData}
                          changeOnSelect
                          options={allAreaList}
                          onChange={() => {
                            return
                          }}
                          placeholder='请选择省市区'
                        />
                      </Form.Item>
                      {/* <Form.Item
                        label=''
                        name='phone'
                        rules={[
                          {
                            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                            message: '请输入正确的联系电话',
                          },
                        ]}
                      >
                        <Input
                          type='number'
                          allowClear
                          placeholder='请输入联系电话'
                          style={{ marginLeft: '20px', width: '294px' }}
                        /> 
                      </Form.Item>*/}
                    </Row>
                  </Col>
                </Row>
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item
                      label=' '
                      name='recipientAddress'
                      getValueFromEvent={stringTrim}
                    >
                      <Input
                        maxLength={100}
                        placeholder='请输入收货地址'
                        style={{ width: '600px' }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Form.Item label='患者收货地址' name='autoAddress'>
                      <Radio.Group defaultValue={0}>
                        <Radio value={0}>自动填充患者上一次的收货地址</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row {...rowProps}>
                  <Col {...colProps}>
                    <Row>
                      <Form.Item label='默认联系电话' name='usePatientPhone'>
                        <Radio.Group
                          defaultValue={'1'}
                          onChange={(v: any) => {
                            setAutoBackFillPhoneFlag(v?.target?.value)
                          }}
                        >
                          <Radio value={'1'}>自动填充患者的联系电话</Radio>
                          <Radio value={'0'}>使用诊所电话</Radio>
                        </Radio.Group>
                      </Form.Item>
                      {autoBackFillPhoneFlag == '0' && (
                        <Form.Item
                          label=''
                          name='phone'
                          rules={[
                            {
                              pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                              message: '请输入正确的联系电话',
                            },
                          ]}
                        >
                          <Input
                            type='number'
                            allowClear
                            placeholder='请输入联系电话'
                            style={{ marginLeft: '20px', width: '262px' }}
                          />
                        </Form.Item>
                      )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}
          </div>
        )}
        {selectPotionType == 0 ? (
          <Row
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '4px',
              marginBottom: '4px',
            }}
          >
            <Button
              style={{ marginRight: '10px' }}
              onClick={(e) => {
                onCancel && onCancel()
                reset()
              }}
            >
              取消
            </Button>
            <Button
              type='primary'
              htmlType='submit'
            >
              确定
            </Button>
          </Row>
        ) : (
          <Row
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              style={{ marginRight: '10px' }}
              onClick={(e) => {
                onCancel && onCancel()
                reset()
              }}
            >
              取消
            </Button>
            {stepValue != 0 && (
              <Button
                type='primary'
                style={{ marginRight: '10px' }}
                onClick={() => {
                  if (stepValue == 1) {
                    setStepValue(0)
                  } else {
                    setStepValue(1)
                  }
                }}
              >
                上一步
              </Button>
            )}
            {stepValue != 2 && (
              <Button
                type='primary'
                disabled={!isOpenReplaceMake ? true : false}
                onClick={() => {
                  const machiningTypes =
                    form.getFieldValue('machiningType') == -1
                      ? ''
                      : form.getFieldValue('machiningType')
                  const potionMoney = form.getFieldValue('potionMoney')
                  if (stepValue == 0) {
                    if (!machiningTypes) {
                      notification.info({ message: '请选择默认委外加工方式' })
                    } else {
                      setStepValue(1)
                      setSubmitValue(form.getFieldsValue())
                    }
                  } else {
                    console.log(!potionMoney, needMoney, "!potionMoney")
                    if (!potionMoney && needMoney) {
                      notification.info({ message: '请选择默认选中费用类别' })
                      return
                    }
                    setStepValue(2)
                    setSubmitValue({ ...submitValue, ...form.getFieldsValue() })
                  }
                }}
              >
                下一步
              </Button>
            )}
            {stepValue == 2 && (
              <Button type='primary' htmlType='submit'>
                确定
              </Button>
            )}
          </Row>
        )}
      </Form>
    </Modal>
  )
}
